import { render, staticRenderFns } from "./TiZhiTiGeResult.vue?vue&type=template&id=504259af&"
import script from "./TiZhiTiGeResult.vue?vue&type=script&lang=js&"
export * from "./TiZhiTiGeResult.vue?vue&type=script&lang=js&"
import style0 from "./TiZhiTiGeResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports